﻿/**
 * Filter
 * Only allow numbers to be inputted into a form field
 * @author Martin Hansen <martin.hansen@valtech.com>
 */

// # Class
export class NumbersOnly {
    constructor(element) {
        element.NumbersOnly = this;

        this._refs = {
            el: element
        };

        this._refs.el.addEventListener('keydown', this._onKeyDown.bind(this));
    }

    /**
     * Filter for when user presses a key in a field to only allow numbers
     * @param {Event} e - Event Interface
     */
    _onKeyDown(e) {

        const keyCode = e.keyCode;
        if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || keyCode == 37 || keyCode == 39 || keyCode == 8 || keyCode == 9 || keyCode == 46) {
            return true;
        }
        else {
            e.preventDefault();
            return false;
        }

    }
}